import { render, staticRenderFns } from "./TransactionDetail.html?vue&type=template&id=71b18dba&scoped=true&"
import script from "./TransactionDetail.js?vue&type=script&lang=js&"
export * from "./TransactionDetail.js?vue&type=script&lang=js&"
import style0 from "./TransactionDetail.scss?vue&type=style&index=0&id=71b18dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b18dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VNavigationDrawer,VRow})
